import { parseCommon } from './helpers';

export const coreReady = ({
  device: { mobile } = {},
  instances = [],
  store: { components = {}, finder = {}, id, type } = {},
} = {}) => {
  const value = {
    ...parseCommon({ ...finder, id, type }),
    device: mobile ? 'MOBILE' : 'DESKTOP_TABLET',
    non_interaction: true,
    step: components['finder'] ? 'BOOKINGENTRANCE' : 'NAVIGATION',
    send_to: instances.map(({ idAnalytics } = {}) => idAnalytics),
  };

  window.gtag('event', 'data_search_info', value);

  return value;
};
